<template>
    <div>

        <div v-if="init && !loading" class="mt-12 mb-12">
            
            <div v-if="filteredVacations">

                <div style="max-height:72vh;" class="border border-gray-300 mb-12 mt-12 overflow-x-scroll w-11/12" v-if="filteredVacations.length > 0">
                    <table class="table w-full">
                        <thead>
                            <tr>
                                <th style="top: -1px;" class="sticky z-20">Request ID</th>
                                <th style="top: -1px;" class="sticky z-20">Subordinate</th>
                                <th style="top: -1px;" class="sticky z-20">From</th>
                                <th style="top: -1px;" class="sticky z-20">To</th>
                                <th style="top: -1px; width: 50px" class="sticky z-20">Hours</th>
                                <th style="top: -1px; width: 50px" class="sticky z-20">Days</th>
                                <th style="top: -1px;" class="sticky z-20">Comments</th>
                                <th style="top: -1px;" class="sticky z-20">
                                    <CellType>
                                        <template v-slot:type>Confirmed</template>
                                        <template v-slot:by>by team leader</template>
                                    </CellType>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(vacation, index) in filteredVacations" :key="vacation._key">
                                <td>
                                    <div class="flex">
                                        <Zondicon icon="news-paper" class="w-4 mr-2 fill-current" />
                                        <span>Req #{{vacation._key.substring(0,3)}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex">
                                        <Zondicon icon="user" class="w-4 mr-4 fill-current" />
                                        <span>{{ getUserName(vacation.user) }}</span>
                                    </div>
                                </td>
                                <td>{{ formatDate(vacation.from) }}</td>
                                <td>{{ formatDate(vacation.to) }}</td>
                                <td class="font-bold" style="width: 50px">{{ vacation.hours }}</td>
                                <td class="font-bold" style="width: 50px">{{ getVacationDays(vacation.hours) }}</td>
                                <td>
                                    <span class="text-xs flex justify-between" v-if="vacation.comments">
                                        <span>
                                            <span>{{ vacation.comments.substr(0, 20) }}</span>
                                            <span v-if="vacation.comments.length > 20">...</span>
                                        </span>
                                        <span 
                                            class="underline cursor-pointer"
                                            v-if="vacation.comments.length > 20"
                                            @click="commentModal = true; comment = vacation.comments">
                                            show more
                                        </span>
                                    </span>
                                </td>

                                <td>
                                    <div v-if="vacation.confirmed">
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                            <div>confirmed</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ getDate(vacation.confirmedDate) }}</span>
                                        </div>
                                    </div>
                                    <button v-else @click="showConfirmModal(vacation._key)" class="btn btn-small btn-secondary mr-2">
                                        Confirm
                                    </button>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-else class="mb-12 mt-12">No vacation requests found! Please be patient and wait for some.</div>

            </div>

            <div v-else>
                There are no vacation requests yet!
            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="confirmModal" @action="confirm" @close="confirmModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Confirm this vacation request</template>
            <template v-slot:body>Are you sure you want to confirm this request?</template>
            <template v-slot:button>Confirm</template>
        </SimpleModal>

        <SimpleModal v-if="commentModal" @close="commentModal = false" :btnClass="'btn-primary'" :doNotShowAction="true">
			<template v-slot:title>Vacation request comment</template>
			<template v-slot:body>{{ comment }}</template>
            <template v-slot:cancel>Close</template>
		</SimpleModal>

    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import { db } from "@/firebase";
import Zondicon from 'vue-zondicons'

import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

    data() {
        return {
            loading: 0,
            loading: false,
            confirmModal: false,
            vacationKey: null,
            unconfirmModal: false,
            unpublishModal: false,
            allVacations: false,
            commentModal: false,
            comment: ''
        }
    },

    computed: {
        
        init() {
            if (this.currentUser && this.allVacations) return true
            return false
        },
    
        ...mapState({
			currentUser: state => state.user.info,
			currentUserSubordinates: state => state.user.subordinates
		}),

        filteredVacations() {
            if (this.allVacations.length > 0) {
                return this.allVacations.sort((a, b) => {
                    return b.from.seconds - a.from.seconds
                })
            }
            else return false;
        },

        // users() {
        //     var users = []
            
        //     if (this.currentUserSubordinates) {
        //         users = this.currentUserSubordinates
        //     }

        //     return users
        // },

        // yearSelect() {
        //     var yearArray = []
        //     for (var i = this.date.year - 5; i <= this.date.year + 3; i++) {
        //         yearArray.push(i)
        //     }
        //     return yearArray;
        // },
    },

    components: {
        SimpleModal,
        Zondicon,
        CellType
    },

    methods: {
        // getMarktime(uid) {
        //     if (this.marktimes) {
        //         return this.marktimes.find(marktime => marktime.user === uid)
        //     }
        //     return false
        // },

        getVacationDays(hours) {
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
            return Math.round((hours/workingHours) * 10) / 10;
        },

        formatDate(date, hours) {
            var format = 'DD.MM.YYYY';
            if (hours) format += ' hh:mm';
            return moment(date.seconds * 1000).format(format);
        },
        
        // showMonthName(i) {
        //     return moment({
        //         month: i
        //     }).format('MMMM')
        // },

        getUserName(uid) {
            if (this.currentUserSubordinates) {
                return this.currentUserSubordinates.find(user => user.uid === uid).name
            }
        },

        showConfirmModal(key) {
            this.vacationKey = key
            this.confirmModal = true
        },

        // openUnconfirmModal(key) {
        //     this.key = key
        //     this.unconfirmModal = true
        // },

        // openUnpublishModal(key) {
        //     this.key = key
        //     this.unpublishModal = true
        // },

        getDate(time) {
            if (time) {
                return moment(time.seconds * 1000).format('DD. MM. YYYY HH:mm')
            }
            return ''
        },

        confirm() {

            db
            .collection('vacations')
            .doc(this.vacationKey)
            .update({
                confirmed: true,
                confirmedDate: new Date()
            })
            .then(() => {
                this.confirmModal = false
                this.$toasted.show(`Confirmed successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.confirmModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        // unconfirm() {

        //     db
        //     .collection('marktimes')
        //     .doc(this.key)
        //     .update({
        //         confirmed: false,
        //         confirmedDate: null
        //     })
        //     .then(() => {
        //         this.unconfirmModal = false
        //         this.$toasted.show(`Unconfirmed successfully!`, {
        //             type: 'success'
        //         })
        //     })
        //     .catch(error => {
        //         this.unconfirmModal = false
        //         this.$toasted.show(`Error: ${error}`, {
        //             type: 'error'
        //         })
        //     });
        // },

        // unpublish() {

        //     db
        //     .collection('marktimes')
        //     .doc(this.key)
        //     .update({
        //         published: false,
        //         publishedDate: null
        //     })
        //     .then(() => {
        //         this.unpublishModal = false
        //         this.$toasted.show(`Unpublished successfully!`, {
        //             type: 'success'
        //         })
        //     })
        //     .catch(error => {
        //         this.unpublishModal = false
        //         this.$toasted.show(`Error: ${error}`, {
        //             type: 'error'
        //         })
        //     });
        // },

        selectDate(add) {

            var time = moment({
                year: this.date.year,
                month: this.date.month
            })
            time.add(add, 'months')
            this.date.month = time.month()
            this.date.year = time.year()

            this.getVacations()
        },

        getVacations() {

            this.loading = true

            if (!this.currentUser.subordinates) {
                this.allVacations = [];
                this.loading = false;
                return;
            }

            if (this.currentUser.subordinates.length === 0) {
                this.allVacations = [];
                this.loading = false
                return
            }
        
            db
            .collection('vacations')
            .where('user', 'in',  this.currentUser.subordinates)
            //.where('month', '==', this.date.month)
            //.where('year', '==', this.date.year)
            .onSnapshot(query => {
                var vacations = []
                query.forEach(function (doc) {
                    console.log(doc.data());
                    var vacation = doc.data()
                    vacation._key = doc.id
                    vacations.push(vacation)
                });
                this.allVacations = vacations;
                this.loading = false
            })

        },

    },

    created() {

        var interval = setInterval(() => {

            if (this.currentUser) {
                console.log('calling getvacation')
                this.getVacations()
                if (!this.currentUserSubordinates) {
                    this.$store.dispatch('user/getSubordinates');
                }
                clearInterval(interval)
            }
        }, 100)

        this.$store.commit('SET_TITLE', 'My Team VACATIONS')
    }

}
</script>